export type RoomStatus = "UPCOMING" | "ACTIVE" | "COMPLETED" | "CANCELLED";

export interface StaffRoomListItem {
  id: string;
  name: string;
  status: RoomStatus;
  startDate: string;
  endDate: string;
  maxMembers: number | null;
  memberCount: number;
  hookLine: string | null;
  cancelledAt: string | null;
  currentSegment: number;
  totalSegments: number;
  daysUntilStart: number | null;
  daysSinceCompletion: number | null;
  book: {
    id: string;
    title: string;
    author: string;
    coverUrl: string | null;
  };
}

export interface StaffRoomDetailSegment {
  id: string;
  segmentNumber: number;
  title: string;
  description: string | null;
  startPage: number | null;
  endPage: number | null;
  startChapter: number | null;
  endChapter: number | null;
}

export interface StaffRoomDetailMember {
  id: string;
  displayName: string | null;
  username: string | null;
  image: string | null;
  joinedAt: string;
  lastActivity: string | null;
  progress: number;
  /** True iff this member is the active facilitator for the room (per BadgeResolver). */
  isFacilitator?: boolean;
}

export interface StaffMargauxPost {
  id: string;
  segmentNumber: number | null;
  createdAt: string;
  reflectionText: string;
  isRecap: boolean;
}

export interface StaffSchedulerLogEntry {
  jobName: string;
  segmentNumber: number | null;
  lastFiredAt: string;
}

export interface StaffReflection {
  id: string;
  segmentNumber: number | null;
  createdAt: string;
  reflectionText: string;
  parentId?: string | null;
  isFacilitatorBadge?: boolean;
  user: {
    id: string;
    displayName: string | null;
    username: string | null;
    image: string | null;
  };
}

export interface StaffFacilitatorAssignment {
  id: string;
  userId: string;
  assignedAt: string;
  unassignedAt: string | null;
  unassignedReason: string | null;
  user: {
    id: string;
    displayName: string | null;
    username: string | null;
    image: string | null;
    email: string;
  } | null;
  assignedBy: {
    id: string;
    displayName: string | null;
    email: string;
  } | null;
  unassignedBy: {
    id: string;
    displayName: string | null;
    email: string;
  } | null;
}

export interface StaffRoomDetail {
  id: string;
  name: string;
  status: RoomStatus;
  startDate: string;
  endDate: string;
  maxMembers: number | null;
  memberCount: number;
  currentSegment: number;
  totalSegments: number;
  hookLine: string | null;
  cancellationReason: string | null;
  cancelledAt: string | null;
  book: {
    id: string;
    title: string;
    author: string;
    coverUrl: string | null;
  };
  segments: StaffRoomDetailSegment[];
  members: StaffRoomDetailMember[];
  margauxPosts: StaffMargauxPost[];
  reflections: StaffReflection[];
  schedulerLog: StaffSchedulerLogEntry[];
  facilitatorAssignments: StaffFacilitatorAssignment[];
}

export interface StaffRoomFilters {
  states: RoomStatus[];
  search: string;
  startsWithin7Days: boolean;
  lowMembers: boolean;
}

export const ALL_STATES: RoomStatus[] = [
  "UPCOMING",
  "ACTIVE",
  "COMPLETED",
  "CANCELLED",
];
